import { apiFetch } from './client.js';

export interface ApuLibraryListItem {
  id: string;
  concepto_descripcion: string;
  unidad: string;
  rendimiento_base: string;
  rendimiento_base_unidad: string;
  source: 'apu_ia' | 'ecostos' | 'manual';
  origin_tenant_id: string | null;
  usage_count: number;
  approved_at: string | null;
  created_at: string;
  updated_at: string;
  has_embedding: boolean;
}

export interface ApuLibraryDetail extends ApuLibraryListItem {
  concepto_normalizado: string;
  dedup_hash: string;
  estructura: Record<string, unknown>;
  contexto_asumido: Record<string, unknown> | null;
  origin_quote_concept_id: string | null;
  approved_by: string | null;
}

export interface ApuLibraryListResult {
  items: ApuLibraryListItem[];
  total: number;
  limit: number;
  offset: number;
}

export interface ApuLibraryPatch {
  conceptoDescripcion?: string;
  unidad?: string;
  rendimientoBase?: number;
  rendimientoBaseUnidad?: string;
  estructura?: Record<string, unknown>;
}

function qs(params: { [k: string]: string | number | undefined }): string {
  const u = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v != null && v !== '') u.set(k, String(v));
  }
  const s = u.toString();
  return s ? `?${s}` : '';
}

export async function listApuLibrary(args: {
  q?: string;
  source?: 'apu_ia' | 'ecostos' | 'manual';
  limit?: number;
  offset?: number;
} = {}): Promise<ApuLibraryListResult> {
  return apiFetch(`/api/v1/staff/apu-library${qs({ ...args })}`);
}

export async function getApuLibraryEntry(id: string): Promise<ApuLibraryDetail> {
  return apiFetch(`/api/v1/staff/apu-library/${id}`);
}

export async function updateApuLibraryEntry(id: string, patch: ApuLibraryPatch): Promise<{ ok: true; id: string }> {
  return apiFetch(`/api/v1/staff/apu-library/${id}`, {
    method: 'PATCH',
    body: patch,
  });
}

export async function deleteApuLibraryEntry(id: string): Promise<{ ok: true; id: string }> {
  return apiFetch(`/api/v1/staff/apu-library/${id}`, { method: 'DELETE' });
}
